// Desktop columns stay expanded; mobile uses native accessible disclosures.
class TeaDucksFooter extends HTMLElement {
  connectedCallback() {
    this.disconnectMediaListener?.();
    this.consentController?.abort();
    this.consentController = new AbortController();
    this.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('a[href="#shopifyReshowConsentBanner"]');
      if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      void window.privacyBanner.showPreferences().catch((error) => {
        console.warn('[Tea Ducks] Cookie preferences could not be opened.', error);
      });
    }, {signal: this.consentController.signal});
    const media = window.matchMedia('(min-width: 768px)');
    const update = () => {
      for (const group of this.querySelectorAll('.td-footer__group')) group.open = media.matches;
    };
    media.addEventListener('change', update);
    this.disconnectMediaListener = () => media.removeEventListener('change', update);
    update();
  }
  disconnectedCallback() { this.disconnectMediaListener?.(); this.consentController?.abort(); }
}
if (!customElements.get('td-footer')) customElements.define('td-footer', TeaDucksFooter);
